import {
  Box,
  Text,
  Flex,
  Image,
  Center,
  CircularProgress,
} from '@chakra-ui/react';

import logo from 'assets/logos/rturn-logo-2023.png';
import cupInHand from 'assets/rcup-soda-in-hand.png';

import GoogleButton from './GoogleButton';

import { LoginViewProps } from './Login.props';

// Brand colors (Pantone 109 / Pantone 425).
const BRAND_YELLOW = '#FFD100';
const BRAND_GRAY = '#53575A';

const LoginView = (props: LoginViewProps) => {
  const { isGoogleAuthLoading, onCredentialResponse } = props;

  return (
    <Flex
      flex={1}
      bg={BRAND_YELLOW}
      justify="center"
      direction="column"
      position="relative"
      overflow="hidden">
      <Flex direction="column" align="center" p={6} zIndex={1}>
        {isGoogleAuthLoading ? (
          <>
            <CircularProgress
              thickness="5px"
              size="100px"
              isIndeterminate
              color={BRAND_GRAY}
            />
            <Text mt={4} color={BRAND_GRAY} fontWeight="600">
              We are loading your dashboard
            </Text>
          </>
        ) : (
          <>
            <Image
              src={logo}
              h="10vh"
              objectFit="contain"
              filter="drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.25))"
            />
            <Text
              my={4}
              fontSize="22px"
              fontWeight="bold"
              color={BRAND_GRAY}
              textAlign="center">
              A better future is in your hands.
            </Text>
            <Center>
              <Box width="400px">
                <GoogleButton onCredentialResponse={onCredentialResponse} />
              </Box>
            </Center>
          </>
        )}
      </Flex>
      <Image
        src={cupInHand}
        alt="r.Cup in hand"
        position="absolute"
        bottom={0}
        right={0}
        maxH="55vh"
        objectFit="contain"
        display={{ base: 'none', md: 'block' }}
        pointerEvents="none"
      />
    </Flex>
  );
};

export default LoginView;
